import React, { useEffect, useRef, useState } from 'react';
import '../css/Home.css';

const Home = () => {
  const firstColumnRef = useRef(null);
  const secondColumnRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const animationFrameRef = useRef(null);
  const scrollPositionsRef = useRef({ first: 0, second: 0 });

  const learningTopics = [
    "Web Development",
    "Data Science",
    "AI & Machine Learning",
    "UI/UX Design",
    "Cloud Computing",
    "E-commerce Solutions"
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const firstColumn = firstColumnRef.current;
    const secondColumn = secondColumnRef.current;

    if (firstColumn && secondColumn) {
      const SCROLL_SPEED = 0.05; // Reduced speed factor (adjust this value to change animation speed)

      const animateScroll = (timestamp) => {
        if (!scrollPositionsRef.current.lastTimestamp) {
          scrollPositionsRef.current.lastTimestamp = timestamp;
        }

        const deltaTime = timestamp - scrollPositionsRef.current.lastTimestamp;
        scrollPositionsRef.current.lastTimestamp = timestamp;

        if (isMobile) {
          // Mobile horizontal scrolling
          scrollPositionsRef.current.first += SCROLL_SPEED * deltaTime;
          scrollPositionsRef.current.second -= SCROLL_SPEED * deltaTime;

          if (scrollPositionsRef.current.first >= firstColumn.scrollWidth / 2) {
            scrollPositionsRef.current.first = 0;
          }

          if (scrollPositionsRef.current.second <= 0) {
            scrollPositionsRef.current.second = secondColumn.scrollWidth / 2;
          }

          firstColumn.scrollLeft = scrollPositionsRef.current.first;
          secondColumn.scrollLeft = scrollPositionsRef.current.second;
        } else {
          // Desktop vertical scrolling
          scrollPositionsRef.current.first += SCROLL_SPEED * deltaTime;
          scrollPositionsRef.current.second -= SCROLL_SPEED * deltaTime;

          if (scrollPositionsRef.current.first >= firstColumn.scrollHeight / 2) {
            scrollPositionsRef.current.first = 0;
          }

          if (scrollPositionsRef.current.second <= 0) {
            scrollPositionsRef.current.second = secondColumn.scrollHeight / 2;
          }

          firstColumn.scrollTop = scrollPositionsRef.current.first;
          secondColumn.scrollTop = scrollPositionsRef.current.second;
        }

        animationFrameRef.current = requestAnimationFrame(animateScroll);
      };

      animationFrameRef.current = requestAnimationFrame(animateScroll);

      return () => {
        if (animationFrameRef.current) {
          cancelAnimationFrame(animationFrameRef.current);
        }
      };
    }
  }, [isMobile]);

  return (
    <>
      <div className="home">
        <div className="left center">
          <h1 className='big-h'>Master new skills with <span>devs</span><span>aura</span><span>.</span></h1>
          <p>Get in touch with us about the skills you're eager to learn. We are here to help you master the topics you're most passionate about and guide you through the learning process effectively. Contact us or email us at <a href="mailto:academy@devsaura.com">academy@devsaura.com</a> with the topics you want to focus on, and we'll tailor the experience to your needs.</p>
        </div>
        <div className={`right ${isMobile ? 'mobile' : ''}`}>
          <div className="scroll-column first" ref={firstColumnRef}>
            {[...learningTopics, ...learningTopics].map((topic, index) => (
              <div key={`first-${index}`} className="item center">
                <p>{topic}</p>
              </div>
            ))}
          </div>
          <div className="scroll-column second" ref={secondColumnRef}>
            {[...learningTopics, ...learningTopics].map((topic, index) => (
              <div key={`second-${index}`} className="item center">
                <p>{topic}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="contact-btn">
        <a href='https://devsaura.com/contact-us' target='_blank' rel='noreferrer noopener'>Contact Now and Start Learning</a>
      </div>
    </>
  );
};

export default Home;